export const Errors: Record<string, keyof typeof ERROR_KEYS> = {
  "20063": "cardDetails",
  "20059": "transactionIssues",
  "200N7": "cardDetails",
  "20051": "transactionIssues",
  "20005": "transactionIssues",
  "20182": "transactionIssues",
  default: "cardDetails",
};

export const ERROR_KEYS = {
  cardDetails: "creditCard.error.cardDetails",
  transactionIssues: "creditCard.error.transactionIssues",
} as const;

export const getErrorKey = (errorCode: string) => {
  const key = Errors[errorCode] ?? Errors.default;
  return ERROR_KEYS[key];
};
